<template>
    <el-dialog width="400px" top="30vh" title="温馨提示" :visible.sync="show" append-to-body :before-close="close" :close-on-click-modal="false"  >
      <el-row class="dialog_wrap">
        <div class="content">截止到挂牌结束时间还未完成交易的，需缴纳<span class="redF">{{transactionViolate}}%</span>的违约金，如有保证金，则先从保证金内进行抵扣，请谨慎操作。</div>
        <div class="btnDia">
          <el-button @click="close">关闭</el-button>
        </div>
      </el-row>
    </el-dialog>
</template>
<script>
export default {
  props:{
    show: {
      type: Boolean, default:false
    },
    transactionViolate: ''
  },
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  methods: {
    close(){
      this.$emit('ruleTipClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog_wrap{
  text-align: center;
  .content{
    text-align: justify;
    width: 90%;
    margin: auto;
  }
}
</style>